<div class="truncate-see-more">
	<div class="text-ellipsis">
		<ng-content></ng-content>
	</div>
	<button *ngIf="showSeeMore" type="button" class="{{ seeMoreClass }}" [translate]="'Actions.' + seeMoreKey" (click)="seeMore.emit()"></button>
</div>
